// Vuetify's base styles, which include the border-box reset its layout
// components assume. Without them a v-container overflows its viewport by its
// own padding, producing the horizontal scroll SPEC 8.2 forbids. The
// per-component styles come from vite-plugin-vuetify; these global ones do not.
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { themeConfig } from '@/theme'

/**
 * Per-component imports are handled by vite-plugin-vuetify's auto-import, so
 * nothing is listed here. A full-library import would ship the entire component
 * set to the family route, which is the cold-open mobile path (SPEC 13.1).
 */
export const vuetify = createVuetify({
  theme: themeConfig,
  defaults: {
    VBtn: { rounded: 'md', variant: 'flat' },
    VCard: { rounded: 'md', elevation: 1 },
    VTextField: { variant: 'outlined', density: 'comfortable' },
  },
})
